<h2 mat-dialog-title>Notification</h2>
<div mat-dialog-content>
    <p>{{data.message}}</p>
</div>
<div mat-dialog-actions align="end" class="modal-footer d-flex gap-10 flex-nowraps">
    <button class="btn btn-primary" (click)="submit()">Open</button>
    <button class="btn btn-secondary" (click)="cancelDialog()">Cancel</button>
</div>